import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { HotKeys } from 'react-hotkeys';

import Button from '../../../../../../../../../../../../components/global/Button';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../../../../constants/image-size-codes';
import SlideThumbnailControls from './components/SlideThumbnailControls';
import { getThumbBySize } from '../../../../../../../../../../../../util/photo';
import AccountCard from '../../../../../../../../../../../../services/cards/components/AccountCard';
import { isIntroLayout } from '../../../../../../helpers';

const propTypes = {
  slideshowSlide: PropTypes.shape({
    photo: {
      id: PropTypes.string,
    },
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  isSeen: PropTypes.bool,
  slideDuration: PropTypes.number,
  slideRemainingTime: PropTypes.number,
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
};

const slideThumbnail = ({
  slideshowSlide,
  onClick,
  isActive,
  isSeen,
  slideDuration,
  slideRemainingTime,
  className,
  onDelete,
  onMoveUp,
  onMoveDown,
  style,
}) => {
  const classes = classNames({
    'secondary-photos-view-slides-step-slide-thumbnail': true,
    'is-active': isActive,
    [className]: !!className,
  });

  const thumbnail = slideshowSlide.account_card
    ? undefined
    : (slideshowSlide.asset_image ??
      getThumbBySize(
        slideshowSlide.photo.watermarked_urls ??
          slideshowSlide.photo.thumbnail_urls,
        IMAGE_SIZE_CODE.SMALL2X,
      ));
  return (
    <HotKeys
      keyMap={{
        onMoveDown: onMoveDown ? 'down' : undefined,
        onMoveUp: onMoveUp ? 'up' : undefined,
      }}
      handlers={{ onMoveDown, onMoveUp }}
      style={style}
    >
      {isActive && (
        <SlideThumbnailControls
          onMoveUp={onMoveUp}
          onDelete={onDelete}
          onMoveDown={onMoveDown}
        />
      )}
      <Button btnStyle="reset" className={classes} onClick={onClick}>
        {(isSeen || isActive) && (
          <div
            className="slide-thumbnail-seen-overlay"
            style={{
              width: isSeen
                ? '100%'
                : `${100 - (100 * slideRemainingTime) / slideDuration}%`,
            }}
          />
        )}
        {slideshowSlide.account_card && (
          <Fragment>
            <div className="w-100">
              <AccountCard
                onElementConfigurationChange={() => {}}
                accountCard={slideshowSlide.account_card}
                animatable={false}
                viewOnly
                disablePhotoWatermarkOverlay
              />
            </div>
            {isIntroLayout(slideshowSlide) && (
              <p className="slide-thumbnail-intro-slide">COVER SLIDE</p>
            )}
          </Fragment>
        )}
        {!slideshowSlide.account_card && (
          <Fragment>
            <img src={thumbnail?.url ?? ''} alt="Slideshow Thumbnail" />
            {slideshowSlide.asset_image && (
              <p className="slide-thumbnail-intro-slide">COVER SLIDE</p>
            )}
          </Fragment>
        )}
      </Button>
    </HotKeys>
  );
};

slideThumbnail.propTypes = propTypes;

export default slideThumbnail;
